import sileo from 'sileo';

const SMLeaveRequestsList = new sileo.Model('hqzen', 'leave-request-list');
const LeaveDetails = new sileo.Model('hqzen', 'leave-details');
const LeaveAmazon = new sileo.Model('hqzen', 'leave-amazon-form-data');
const SMIncidentReports = new sileo.Model('hqzen', 'sm-incident-reports');
const DisciplinaryActionForm = new sileo.Model('hqzen', 'sm-disciplinary-action-form-resource');
const SeparationTermination = new sileo.Model('hqzen', 'sme-separation-termination-resource');
const IncidentReportsCount = new sileo.Model('hqzen', 'incident-reports-list-count');
const IncidentReportDetails = new sileo.Model('hqzen', 'sm-incident-report-details');
const EmployeeDocuments = new sileo.Model('hqzen', 'employee-documents');
const EmployeesList = new sileo.Model('hqzen', 'employees-list');
const EmployeePayrollHistory = new sileo.Model('hqzen', 'employee-payroll-history');
const EmployeeDetails = new sileo.Model('hqzen', 'employee-details');
const SimpleEmployeeDetails = new sileo.Model('hqzen', 'simple-employee-details');
const PolicyAction = new sileo.Model('hqzen', 'policy-action');
const PolicySection = new sileo.Model('hqzen', 'policy-section');
const PolicyOffense = new sileo.Model('hqzen', 'policy-offense');
const IncidentReport = new sileo.Model('hqzen', 'incident-report');
const IncidentReportAttachment = new sileo.Model('hqzen', 'incident-report-amazon-form-data');
const LeaveHistory = new sileo.Model('hqzen', 'leave-history-log');
const EmployeeDAFList = new sileo.Model('hqzen', 'employee-daf-list');
const EmployeeIRList = new sileo.Model('hqzen', 'employee-ir-list');
const AccountabilityItemDetails = new sileo.Model('hqzen', 'accountability-details');
const SMEAccountabilityEditHistory = new sileo.Model('hqzen', 'sme-accountability-edit-history');
const AccountabilitiesListResource = new sileo.Model('hqzen', 'accountabilities-list');
const AccountabilitiesCount = new sileo.Model('hqzen', 'accountabilities-count');
const AdministrativeLeaveCount = new sileo.Model('hqzen', 'administrative-leaves-count');
const SMDafCount = new sileo.Model('hqzen', 'sm-daf-count-resource');
const DisciplinaryActionFormDetails = new sileo.Model('hqzen', 'sm-disciplinary-action-form-details-resource');
const DisciplinaryActionFormList = new sileo.Model('hqzen', 'sm-disciplinary-action-form-list-resource');
const HRDisciplinaryActionFormList = new sileo.Model('hqzen', 'hr-disciplinary-action-forms-resource');
const SMEResignationDetails = new sileo.Model('hqzen', 'sme-resignation-details');
const ResignationList = new sileo.Model('hqzen', 'resignation-list');
const ResignationAcknowledgements = new sileo.Model('hqzen', 'resignation-acknowledgement');
const SeparationAmazon = new sileo.Model('hqzen', 'separation-amazon-form-data');
const EmployeesListCount = new sileo.Model('hqzen', 'employees-list-count');
const ClearanceList = new sileo.Model('hqzen', 'clearance-list');
const ClearanceDetails = new sileo.Model('hqzen', 'clearance-details');
const ClearanceAccountabilities = new sileo.Model('hqzen', 'clearance-accountabilities');
const SMEUsers = new sileo.Model('hqzen', 'sme-users');
const SMIRDetails = new sileo.Model('hqzen', 'sm-ir-details');
const SMEDocumentEmployeeList = new sileo.Model('hqzen', 'manager-supervisor-employees-documents');
const SMEDocumentEmailSender = new sileo.Model('hqzen', 'manager-supervisor-email-sender');
const SMEDepartmentIRDetails = new sileo.Model('hqzen', 'sme-department-ir-details');
const SMEResignationListPendingCount = new sileo.Model('hqzen', 'resignation-pending-count');
const SMEClearanceListPedningCount = new sileo.Model('hqzen', 'clearance-pending-count');
const updateDafStatusToArchive = new sileo.Model('hqzen', 'employee-daf-details');
const SMETerminationListPendingCount =
    new sileo.Model('hqzen', 'sme-separation-termination-pending-count');
const SMEForcedTerminationList = new sileo.Model('hqzen', 'sme-force-separation');
const DeactivatedDocumentEmployeeList = new sileo.Model('hqzen', 'deactivated-employees-documents');

const state = {
    employeesCount: 0
};

const getters = {};

const mutations = {
    setEmployeesCount(state, employeesCount) {
        state.employeesCount = employeesCount;
    },
};

const actions = {
    sendEmailToEmployees(context, payload) {
        const formData = new FormData();
        for (let key in Object.keys(payload)) {
            formData.append(key, payload[key]);
        }
        return SMEDocumentEmailSender.objects.create(payload);
    },

    fetchSMLeaveRequestList(context, filters) {
        return SMLeaveRequestsList.objects.filter(filters);
    },

    fetchEmployeeLeaveHistory(context,filters) {
        return LeaveHistory.objects.filter(filters);
    },

    fetchEmployeesList(context, filters) {
        return EmployeesList.objects.filter(filters);
    },

    getSpecificLeaveDetails(context, filters) {
        return LeaveDetails.objects.filter(filters);
    },

    getEmployeeDetails(context, filters) {
        return EmployeeDetails.objects.filter(filters);
    },

    getEmployeeInformation(context, pk) {
        return SimpleEmployeeDetails.objects.get(pk);
    },

    fetchPolicyActions(context, filters) {
        return PolicyAction.objects.filter(filters);
    },

    fetchPolicySections(context, filters) {
        return PolicySection.objects.filter(filters);
    },

    fetchPolicyOffenses(context, filters) {
        return PolicyOffense.objects.filter(filters);
    },

    createIncidentReport(context, payload) {
        let signature = payload.signature;
        let formData = new FormData();
        return new Promise((resolve, reject) => {
            signature.save(async(blob) => {
                formData.append('signature_file', blob, 'signature.png');
                delete payload.signature;
                for (let key in payload) {
                    formData.append(key, payload[key]);
                }
                resolve(await IncidentReport.objects.create(formData));
            });
        });
    },

    async updateIncidentReport(context, payload) {
        let pk = payload.pk;
        let signature = payload.signature;
        let formData = new FormData();
        for (let key in payload) {
            formData.append(key, payload[key]);
        }
        if (signature) {
            return new Promise((resolve, reject) => {
                signature.save(async(blob) => {
                    formData.append('signature_file', blob, 'signature.png');
                    delete payload.signature;
                    resolve(await IncidentReport.objects.update({ pk }, formData));
                });
            });
        }
        else
            await IncidentReport.objects.update({}, formData);
    },

    async archiveOrCancelIncidentReport(context, payload) {
        let pk = payload.pk;
        let formData = new FormData();
        for (let key in payload) {
            formData.append(key, payload[key]);
        }
        await IncidentReport.objects.update({ pk }, formData);
    },

    async fetchIncidentReportAmazonFormData(context, file_type) {
        return IncidentReportAttachment.objects.filter(
            { file_type: file_type }).then(data => {
                return data.amazon;
            });
    },

    async fetchIncidentReportSignatureAmazonFormData(context, file_type) {
        return IncidentReportAttachment.objects.filter(
            { file_type: file_type,
            signature_attachment: true }).then(data => {
            return data.amazon;
        });
    },

    async uploadToAmazon(context) {
        return await LeaveAmazon.objects.filter(
            { signature_attachment: true }).then(data => {
            return data.amazon;
        });
    },

    async updateLeave(context, data) {
        let form = new FormData();
        form.append('status', data.status);
        form.append('reject_reason', data.reject_reason);
        form.append('signature_uuid', data.signature_uuid);
        form.append('employment', data.employment);
        form.append('location', data.location);
        form.append('is_archived', data.is_archived);

        if (data.is_unarchived) {
            form.append('is_unarchived', data.is_unarchived);
        }

        if (data.is_hr) {
            form.append('is_hr', data.is_hr);
        }

        return await LeaveDetails.objects.update({ pk: data.pk }, form);
    },

    fetchIncidentReports(context, filters) {
        return SMIncidentReports.objects.filter(filters);
    },

    fetchEmployeesListCount({ commit }, filters) {
        return EmployeesListCount.objects.filter(filters).then(response => {
            commit('setEmployeesCount', response);
            return response;
        });
    },

    fetchIncidentReportDetails(context, filters) {
        return IncidentReportDetails.objects.filter(filters);
    },

    fetchDafs(context, filters) {
        return DisciplinaryActionForm.objects.filter(filters);
    },

    fetchIncidentReportsCount(context, filters) {
        return IncidentReportsCount.objects.filter(filters);
    },

    fetch201Files(context, filters) {
        return EmployeeDocuments.objects.filter(filters);
    },

    fetchEmployeePayrollHistory(context, filters) {
        return EmployeePayrollHistory.objects.filter(filters);
    },

    fetchEmployeeDAFList(context, filters) {
        return EmployeeDAFList.objects.filter(filters);
    },
    // this method is used for ViewDAFModal's details
    getIncidentReportDetails(context, pk) {
        return SMIRDetails.objects.get(pk);
    },

    fetchEmployeeIncidentReportList(context, filters) {
        return EmployeeIRList.objects.filter(filters);
    },

    fetchPendingSMDafCount(context, filters) {
        return SMDafCount.objects.filter(filters);
    },

    fetchAccountabilityItemDetails(context, filters) {
        return AccountabilityItemDetails.objects.filter(filters);
    },

    fetchSMEAccountabilityEditHistory(context, filters) {
        return SMEAccountabilityEditHistory.objects.filter(filters);
    },

    fetchAccountabilitiesList(context, filters) {
        return AccountabilitiesListResource.objects.filter(filters);
    },

    fetchAccountabilitiesCount(context, filters) {
        return AccountabilitiesCount.objects.filter(filters);
    },

    fetchAdministrativeLeaveCount(context, filters) {
        return AdministrativeLeaveCount.objects.filter(filters);
    },

    fetchDisciplinaryActionFormDetails(context, filters) {
        return DisciplinaryActionFormDetails.objects.get(filters);
    },

    fetchDisciplinaryActionFormList(context, filters) {
        return DisciplinaryActionFormList.objects.filter(filters);
    },

    fetchHRDisciplinaryActionFormList(context, filters) {
        return HRDisciplinaryActionFormList.objects.filter(filters);
    },

    updateDisciplinaryActionArchive(context, pk) {
        return DisciplinaryActionFormList.objects.update({ pk });
    },

    fetchResignationList(context, filters) {
        return ResignationList.objects.filter(filters);
    },

    getSMEResignationDetails(context, payload) {
        return SMEResignationDetails.objects.get(payload);
    },

    async updateSMEResignation(context, data) {
        let form = new FormData();
        form.append('approved_by', data.approved_by);
        form.append('approval_signature_uuid', data.approval_signature_uuid);
        form.append('approval_location', data.approval_location);
        return await SMEResignationDetails.objects.update({ pk: data.pk }, form);
    },

    async separationUploadToAmazon(context) {
        return await SeparationAmazon.objects.filter(
            { signature_attachment: true }).then(data => {
            return data.amazon;
        });
    },

    createResignationAcknowledgements(context, payload) {
        return ResignationAcknowledgements.objects.create(payload);
    },

    fetchClearanceList(context, filters) {
        return ClearanceList.objects.filter(filters);
    },

    fetchClearanceAccountabilities(context, filters) {
        return ClearanceAccountabilities.objects.filter(filters);
    },

    getClearanceDetails(context, pk) {
        return ClearanceDetails.objects.get(pk);
    },

    updateClearanceSignatories(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return ClearanceDetails.objects.update({ pk: data.pk }, form);
    },

    fetchSMEUsers(context, filters) {
        return SMEUsers.objects.filter(filters);
    },

    fetchSMEDocumentEmployeeList(context, filters) {
        return SMEDocumentEmployeeList.objects.filter(filters);
    },

    fetchSMEDepartmentIRDetails(context, filters) {
        return SMEDepartmentIRDetails.objects.filter(filters);
    },

    fetchSMETerminationList(context, filters) {
        return SeparationTermination.objects.filter(filters);
    },

    fetchSMEResignationListPendingCount(context, filter) {
        return SMEResignationListPendingCount.objects.filter(filter);
    },

    fetchClearanceListPendingCount(context, filter) {
        return SMEClearanceListPedningCount.objects.filter(filter);
    },

    updateDafStatusToArchived(context, payload) {
        let pk = payload.pk;
        let formData = new FormData();
        for (let key in payload) {
        formData.append(key, payload[key]);
        }
        return updateDafStatusToArchive.objects.update({ pk }, formData);
        },

    fetchSMETerminationListPendingCount(context, filter) {
        return SMETerminationListPendingCount.objects.filter(filter);
    },

    fetchSMEForcedTerminationList(context, filter) {
        return SMEForcedTerminationList.objects.filter(filter);
    },

    fetchDeactivatedDocumentEmployeeList(_, filter) {
        return DeactivatedDocumentEmployeeList.objects.filter(filter);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
